
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-avatar-generator",
      function () {
        return require("private-next-pages/ai-avatar-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-avatar-generator"])
      });
    }
  